import { useState } from "react"
import { Button, Col, Form, Row, Spinner } from "react-bootstrap"
import http from "../helpers/Request"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

function PartnerForm() {
  const [form, setForm] = useState({
    fullname: '',
    phone: '',
    email: '',
    company: '',
    company_address: '',
    department: '',
    job_title: '',
    message: ''
  })
  const [checkbox, setCheckbox] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true)
    
    http.post('/api/partner', {
      full_name: form.fullname,
      phone: form.phone,
      email: form.email,
      company: form.company,
      company_address: form.company_address,
      department: form.department,
      job_title: form.job_title,
      message: form.message,
      consent: checkbox ? 1 : 0
    }).then(res => {
      MySwal.fire({
        title: 'Success',
        text: 'Thank for you for your response, we will contacting you',
        icon: 'success'
      })

      setForm({
        fullname: '',
        phone: '',
        email: '',
        company: '',
        company_address: '',
        department: '',
        job_title: '',
        message: ''
      })
      setCheckbox(false);
    }).catch(err => {
       MySwal.fire({
          title: 'Error',
          text: 'Something went wrong...',
          icon: 'error'
        })
    }).finally(() => {
      setLoading(false)
    })
  };

  return(
    <div className='card-shadow'>
      <Row className='category request-form'>
        <Col xs={12} md={6}>
          <div className="desc">
            <div className='title mb-4'><h2>Ready to grow with us? Fill out the form and let’s start building something great.</h2></div>
            <p>We’ll review your application and get in touch to guide you through the next steps. Together, we’ll make the cloud safer and the business stronger.</p>
            <br/>
            <p>Let’s secure the cloud, together.</p>
            {/* <div className="mt-5 d-flex flex-wrap align-items-center gap-3">
              <span className="fw-semibold">Already a partner?</span>
              <Button
                variant="brand"
                className="text-brand"
                style={{ border: '1px solid #1b64f2', color: '#1b64f2', background: '#ffffff' }}
                href={process.env.REACT_APP_PORTAL_URL}
                target="_blank"
                rel="noreferrer"
              >
                Login
              </Button>
            </div> */}
          </div>
        </Col>
        <Col xs={12} md={6}>
          <div className='form'>
            <div className='text-center'><strong>Become Siberwander Partner</strong></div>
            <Form className="mt-4" onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold mb-0">Full Name<span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Full Name"
                  value={form.fullname}
                  onChange={(event) => setForm(state => ({...state, fullname: event.target.value}))}
                  disabled={loading}
                  required
                />
                <Form.Label className="fw-semibold mb-0 mt-2">Mobile Phone<span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Mobile Phone"
                  value={form.phone}
                  onChange={(event) => setForm(state => ({...state, phone: event.target.value}))}
                  disabled={loading}
                  required
                />
                <Form.Label className="fw-semibold mb-0 mt-2">Business Email<span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Business Email"
                  value={form.email}
                  onChange={(event) => setForm(state => ({...state, email: event.target.value}))}
                  disabled={loading}
                  required
                />
                <Form.Label className="fw-semibold mb-0 mt-2">Company Legal Name<span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Company Legal Name"
                  value={form.company}
                  onChange={(event) => setForm(state => ({...state, company: event.target.value}))}
                  disabled={loading}
                  required
                />
                <Form.Label className="fw-semibold mb-0 mt-2">Company Address<span className="text-danger">*</span></Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="Company Address"
                  value={form.company_address}
                  onChange={(event) => setForm(state => ({...state, company_address: event.target.value}))}
                  disabled={loading}
                  required
                  rows={4}
                />
                <Form.Label className="fw-semibold mb-0 mt-2">Job Title<span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Job Title"
                  value={form.job_title}
                  onChange={(event) => setForm(state => ({...state, job_title: event.target.value}))}
                  disabled={loading}
                  required
                />
                <Form.Label className="fw-semibold mb-0 mt-2">Department<span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Department"
                  value={form.department}
                  onChange={(event) => setForm(state => ({...state, department: event.target.value}))}
                  disabled={loading}
                  required
                />
                <Form.Label className="fw-semibold mb-0 mt-2">Message<span className="text-danger">*</span></Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="Message"
                  value={form.message}
                  onChange={(event) => setForm(state => ({...state, message: event.target.value}))}
                  disabled={loading}
                  required
                  rows={4}
                />
                <div className="d-flex flex-row gap-3 mt-2">
                  <Form.Check
                    type={'checkbox'}
                    checked={checkbox}
                    readOnly
                    onClick={()=>setCheckbox(!checkbox)}
                  />
                  <p className="text-justify">By checking this box, I consent to receive Insight marketing emails. We respect your privacy and will not share your personal information with any other company, person or identity.</p>
                </div>
                <Form.Group className="mb-3 mt-4">
                  <Button variant="brand" disabled={loading||!checkbox} style={{width:'100%'}} type="submit">
                    {
                      loading?(
                        <>
                          <Spinner animation="border" size="sm" className="me-2"/> Loading
                        </>
                      ):(
                        <>Submit</>
                      )
                    }
                  </Button>
                </Form.Group>
              </Form.Group>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default PartnerForm
